export default __webpack_public_path__ + "static/media/recorte_3.86cfba94.JPG";